// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"1117a16d","787":"b9ec5bb0"}[chunkId] + ".chunk.js";
};